module.exports = __webpack_public_path__ + "static/media/11.5ec67772.jpg";